import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { Route as ImplementationsRoute } from './_index';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { Route as ImplementationDetailsRoute } from '~/core/routes/settings/implementations/[implementationId]/_index';
import { Route as FacilityDetailsRoute } from '~/core/routes/settings/implementations/[implementationId]/facilities/[facilityId]/_index';
import { Route as FacilityMechanicsDetailsRoute } from '~/core/routes/settings/implementations/[implementationId]/facilities/[facilityId]/facility-mechanics/_index';
import { Route as CreateImplementationRoute } from '~/core/routes/settings/implementations/create/_index';

export const permissions: PermissionsFn = (context) => {
  if (context.user.organization.slug === 'valleyBank') return 'deny';
  return context.flags.productsImplementationPortalPermissions;
};

// Exports
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      >
        <Outlet />
      </Flex>
    </PermissionGuard>
  ),
  // Relative to /implementations/*
  children: [
    { index: true, element: <ImplementationsRoute /> },
    { path: 'create', element: <CreateImplementationRoute /> },
    { path: ':implementationId', element: <ImplementationDetailsRoute /> },
    {
      path: ':implementationId/facilities/:facilityId',
      element: <FacilityDetailsRoute />,
    },
    {
      path: ':implementationId/facilities/:facilityId/facility-mechanics',
      element: <FacilityMechanicsDetailsRoute />,
    },
    { path: '*', element: <Navigate to="./" replace /> },
  ],
};
